import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-record-card-grid',
  templateUrl: './record-card-grid.component.html',
  styleUrls: ['./record-card-grid.component.scss'],
})
export class RecordCardGridComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
